import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  CONTACT_EMAIL, CONTACT_NAME, DURATION_OF_INVESTMENT, EQUITY, INVESTOR, SHARE_CATEGORY,
} from 'constants/formFields';
import { DEFAULT_OPTION, OPTION_CATEGORY_INVESTOR } from 'constants/general';
import getValueOption from 'utils/getOptionValue';
import { investorCreateSchema } from 'utils/validators';

import type { TInvestorCreateSchema } from 'utils/validators';
import type ICreateInvestorForm from '../interfaces/ICreateInvestorForm';

const useCreateInvestorForm = ({ isPageLoading, selectedItem }: ICreateInvestorForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TInvestorCreateSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(investorCreateSchema),
    defaultValues: {
      [INVESTOR]: '',
      [CONTACT_NAME]: '',
      [CONTACT_EMAIL]: '',
      [EQUITY]: '',
      [SHARE_CATEGORY]: DEFAULT_OPTION,
      [DURATION_OF_INVESTMENT]: '',
    },
  });

  useEffect(() => {
    if (selectedItem) {
      setValue(INVESTOR, selectedItem.name);
      setValue(CONTACT_NAME, selectedItem.contactName);
      setValue(CONTACT_EMAIL, selectedItem.contactEmail);
      setValue(EQUITY, `${selectedItem.equityPercentage}`);
      setValue(DURATION_OF_INVESTMENT, selectedItem.investmentDuration);
      setValue(SHARE_CATEGORY, getValueOption(OPTION_CATEGORY_INVESTOR, selectedItem.shareCategory));
    }
  }, [selectedItem, setValue]);

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    resetField,
  };
};

export default useCreateInvestorForm;
